import React, { useState, useEffect, useRef } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import logo from "../assets/logo.png";
import footer from "../assets/footerm.png";
import { Link, NavLink } from "react-router-dom";

const MobileHeader = ({ title }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServiceOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <>
      <div className="app-container">
        {" "}
        {/* parent should NOT have overflow restrictions */}
        <div className={`phone-header efforted sticky-header`}>
          <div className="top-row d-flex align-items-center justify-content-between  py-2">
            <div className="left-icon">
              <img
                src={footer}
                className="navbar-toggler-icon"
                style={{ width: 40, height: 40, cursor: "pointer" }}
                onClick={() => setMenuOpen(!menuOpen)}
              />
            </div>

            <img src={logo} className="ph-logo" alt="Logo" />

            <div className="right-space"></div>
          </div>
        </div>
        {/* Page content */}
        <div className="page-content">{/* all other sections */}</div>
      </div>

      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>
      )}

      <div className={`side-menu ${menuOpen ? "open" : ""}`}>
        <ul className="menu-list efforted">
          <li>
            <Link
              className="nav-link mb-4"
              to="/"
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>

          <li ref={dropdownRef}>
            <div
              className="menu-item nav-link mb-4"
              onClick={() => setServiceOpen(!serviceOpen)}
            >
              Services
              <ChevronDown
                size={18}
                style={{
                  transition: "0.3s",
                  transform: serviceOpen ? "rotate(180deg)" : "rotate(0)",
                  marginLeft: "20px",
                }}
              />
            </div>

            <ul className={`dropdown ${serviceOpen ? "show" : ""}`}>
              {[
                { label: "aepsservice", value: "AEPS" },
                { label: "bbpsservice", value: "BBPS" },
                { label: "upiatmservice", value: "UPI ATM" },
                { label: "ittechnology", value: "IT Technology" },
                { label: "taxationservices", value: "Taxation Services" },
                { label: "atminstallation", value: "ATM Installation" },
                { label: "microatmservices", value: "Micro ATM Services" },
                { label: "registationservices",
                  value: "Registration Services", },
                { label: "aadharpayservices", value: "Aadhaar Pay Services" },
                { label: "apiintegration", value: "API Integration" },
              ].map((s) => (
                <li key={s.label}>
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "text-orange fw-bold" : ""}`
                    }
                    to={`/service/${s.label}`}
                    onClick={() => {
                      setMenuOpen(false);
                      setServiceOpen(false);
                    }}
                  >
                    {s.value}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          {/* <li>
            <a
              className="nav-link mb-4"
              href="#how-it-works"
              onClick={() => setMenuOpen(false)}
            >
              How it Works
            </a>
          </li>

          <li>
            <a
              className="nav-link mb-4"
              href="#faq"
              onClick={() => setMenuOpen(false)}
            >
              FAQ
            </a>
          </li> */}

          <li>
            <Link
              className="nav-link mb-4"
              to="/contact"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
          </li>

          <button className="get-started-btn">
            Become a Partner <ArrowRight size={16} />
          </button>
        </ul>
      </div>
    </>
  );
};

const MainHeader = ({ title }) => {
  return (
    <>
      {/* <DesktopHeader /> */}
      <MobileHeader title={title} />
    </>
  );
};

export default MainHeader;
